<div *ngIf="interferenceTestService.detailsTab.selected != null &&
            interferenceTestService.detailsTab.active && !tabsService.minimizeScreenMode">

  <ng-container *ngIf="interferenceTestService.allowedStates()">
    <div class="fields__container__tabs">
      <div (click)="activateTab(0)" class="fields__container__tabs__item">
        <a [ngClass]="this.interferenceTestService.detailsTab.tab == 0 ? 'active' : ''" href="#">Information</a>
      </div>

      <ng-container *ngIf="!interferenceTestService.allowedStates(InterferenceTestModelStates.Draft)">
        <div (click)="activateTab(1)" class="fields__container__tabs__item">
          <a [ngClass]="this.interferenceTestService.detailsTab.tab == 1 ? 'active' : ''" href="#">Approval</a>
        </div>
      </ng-container>

      <ng-container *ngIf="!interferenceTestService.allowedStates(InterferenceTestModelStates.Draft, InterferenceTestModelStates.Approval)">
        <div (click)="activateTab(2)" class="fields__container__tabs__item">
          <a [ngClass]="this.interferenceTestService.detailsTab.tab == 2 ? 'active' : ''" href="#">Execution</a>
        </div>
      </ng-container>
    </div>
  </ng-container>


  <!--Information-->
  <ng-container *ngIf="this.interferenceTestService.detailsTab.tab == 0">
    <fieldset [disabled]="!interferenceTestService.allowedStates(InterferenceTestModelStates.Draft, InterferenceTestModelStates.Approval)
                         || !gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)">
      <form #formInfo="ngForm" [class.fullscreen]="tabsService.fullScreenMode" autocomplete="off" class="active">

        <div class="fields__block">
          <div class="fields__block__section">
            <div class="title">
              <h4>Details</h4><span> </span>
            </div>
            <div class="input-fields">
              <div>
                <label for="name">Name</label>
                <input [(ngModel)]="interferenceTestService.detailsTab.selected.name" id="name" name="name"
                       required type="text"/>
              </div>

              <div>
                <label for="state">State</label>
                <input [value]="interferenceTestService.detailsTab.selected.getState()" id="state" name="state" readonly
                       required type="text"/>
              </div>
            </div>
            <div class="dropdown-fields">
              <div>
                <label for="type">Type</label>
                <select [(ngModel)]="interferenceTestService.detailsTab.selected.type" id="type" name="type"
                        required>
                  <option value="jamming">Jamming</option>
                  <option value="spoofing">Spoofing</option>
                </select>
              </div>

              <div>
                <label for="purpose">Purpose</label>
                <select [(ngModel)]="interferenceTestService.detailsTab.selected.purpose" id="purpose" name="purpose"
                        required>

                  <option *ngFor="let item of InterferenceTestModel.fieldsValues.purpose"
                          [value]="item.value">{{ item.display }}
                  </option>
                </select>
              </div>

              <div>
                <label for="organization">Organization</label>
                <select [(ngModel)]="interferenceTestService.detailsTab.selected.organization" id="organization" name="organization"
                        required>

                  <option *ngFor="let item of InterferenceTestModel.fieldsValues.organization"
                          [value]="item.value">{{ item.display }}
                  </option>
                </select>
              </div>

              <div>
                <label for="probability">Probability</label>
                <select [(ngModel)]="interferenceTestService.detailsTab.selected.probability" id="probability" name="probabiltiy"
                        required>

                  <option *ngFor="let item of InterferenceTestModel.fieldsValues.probability"
                          [value]="item.value">{{ item.display }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="fields__block__section">
            <div class="title">
              <h4>Visibility</h4><span> </span>
            </div>

            <div class="input-fields">
              <div>
                <label for="maskRadius">Generic Mask Radius</label>
                <input [(ngModel)]="interferenceTestService.detailsTab.selected.deviceMaskRadius" id="maskRadius"
                       min="0" name="hideDevicesRange" type="number"/>
              </div>
            </div>
          </div>


          <grit-groups
            [(accessGroup)]="interferenceTestService.detailsTab.selected.groupAccess"
            [(originatorGroup)]="interferenceTestService.detailsTab.selected.groupOriginator"
            [(visibilityGroup)]="interferenceTestService.detailsTab.selected.groupVisibility">
          </grit-groups>
        </div>

        <div class="fields__block">
          <div class="fields__block__section">
            <div class="title">
              <h4>Dates</h4><span> </span>
            </div>

            <div class="input-fields">
              <div>
                <label for="dateStart">Start Date</label>
                <input [(ngModel)]="interferenceTestService.detailsTab.selected.dateStartISO" id="dateStart" name="dateStart" required
                       type="datetime-local"/>
                <span class="error">
                  Please note: The dates you enter are in UTC (Coordinated Universal Time)
                </span>
              </div>


              <div>
                <label for="dateEnd">End Date</label>
                <input [(ngModel)]="interferenceTestService.detailsTab.selected.dateEndISO" id="dateEnd" name="dateEnd" required
                       type="datetime-local"/>
              </div>
            </div>
          </div>

          <div class="fields__block__section">
            <div class="title">
              <h4>Contacts</h4><span> </span>
            </div>

            <div class="input-fields">
              <div>
                <label for="interruptionContact">Interruption Email</label>
                <input [(ngModel)]="interferenceTestService.detailsTab.selected.interruptionEmail" id="interruptionContact"
                       name="interruptionContact" pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$"
                       required
                       type="email"/>
              </div>
            </div>
          </div>

          <ng-container *ngIf="interferenceTestService.allowedStates()">
            <div class="fields__block__section">
              <div class="title">
                <h4>Area</h4><span> </span>
              </div>

              <div class="input-fields">
                <div>
                  <label>Define Test Area:</label>
                  <div class="btn" style="border: none">
                    <button (click)="defineTestArea('Polygon')"
                            [class.active]="this.drawArea?.get('type') == 'Polygon'"
                            [ngClass]="interferenceTestService.detailsTab.selected.testArea != null ? 'selected' : 'ng-invalid'"
                            type="button">Polygon
                    </button>
                    <button (click)="defineTestArea('Circle')"
                            [class.active]="this.drawArea?.get('type') == 'Circle'"
                            [ngClass]="interferenceTestService.detailsTab.selected.testArea != null ? 'selected' : 'ng-invalid'"
                            type="button">Circle
                    </button>
                  </div>
                </div>
                <div>
                  <label for="calc_id">Calculation</label>
                  <select [(ngModel)]="interferenceTestService.detailsTab.selected.calculationId" id="calc_id"
                          name="calc_id" [class.ng-invalid]="interferenceTestService.projectInterferenceTest.calculationId == undefined">

                    <ng-container *ngFor="let child of getCalculations()">
                      <option *ngIf="child.type == 'Impact Assessment'" value="{{child.calcID}}">{{ child.name }}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </ng-container>

        </div>

        <div class="fields__btn">
          <ng-container *ngIf="interferenceTestService.allowedStates(InterferenceTestModelStates.Draft, InterferenceTestModelStates.Approval)
                            && gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)">

            <ng-container *ngIf="interferenceTestService.allowedStates(InterferenceTestModelStates.Draft)
                               && gritUserService.allowedRoles(GritUserRoleGroup.FullUser)">

              <button (click)="trigger('Submit')"
                      [disabled]="saveButton.disabled ||
                  interferenceTestService.projectInterferenceTest.testArea == null ||
                  interferenceTestService.projectInterferenceTest.calculationId == undefined ||
                  !gritUserService.allowedRoles(GritUserRoleGroup.FullUser)"
                      [ngClass]="saveButton.disabled ||
                  interferenceTestService.projectInterferenceTest.testArea == null ||
                  interferenceTestService.projectInterferenceTest.calculationId == undefined ? 'gray' : 'white'"
                      type="button">Submit
              </button>
            </ng-container>

            <button #saveButton (click)="save()"
                    [disabled]="!formInfo.form.valid || !groupsNotNull(interferenceTestService.detailsTab.selected)"
                    [ngClass]="saveButton.disabled ? 'gray' : 'blue'"
                    type="button">Save
            </button>

            <button (click)="tabsService.closeTab()" class="gray">Cancel</button>
          </ng-container>

          <ng-container *ngIf="interferenceTestService.allowedStates(InterferenceTestModelStates.Archived)
                            || !interferenceTestService.allowedStates()">
            <a (click)="focus()" [ngClass]="this.interferenceTestService.focusPublicInterferenceTest != null? 'gray' : 'blue'">Focus</a>
          </ng-container>
        </div>
      </form>
    </fieldset>
  </ng-container>

  <!--Approval-->
  <ng-container *ngIf="this.interferenceTestService.detailsTab.tab == 1">
    <form #formApproval="ngForm" [class.fullscreen]="tabsService.fullScreenMode" autocomplete="off" class="active">
      <fieldset class="fields__block"
                [disabled]="!interferenceTestService.allowedStates(InterferenceTestModelStates.Approval)
                || !gritUserService.allowedRoles(GritUserRoleGroup.ApprovingEntity)">
        <div class="fields__block__section">
          <div class="title">
            <h4>Approval</h4><span> </span>
          </div>
          <div class="dropdown-fields">
            <div>
              <label for="area">Area</label>
              <select [(ngModel)]="interferenceTestService.detailsTab.selected.areaType" id="area" name="area"
                      required>
                <option value="normal">Normal</option>
                <option value="danger">Danger</option>
                <option value="restricted">Restricted</option>
              </select>
            </div>
          </div>
        </div>

        <div class="fields__block__section">
          <div class="title">
            <h4>Stakeholders</h4><span> </span>
          </div>

          <div class="table-fields">
            <div style="max-height: 150px;overflow-y: scroll;">
              <table>
                <thead>
                <tr>
                  <th class="text-nowrap" scope="col" style="width: 1%">Actions</th>
                  <th scope="col">Email</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let el of interferenceTestService.detailsTab.selected.stakeholders; let i = index">
                  <td>
                    <div style="display: flex; justify-content: space-evenly">
                      <input (click)="editStakeholder(i)" src="/assets/img/edit-window-blue.svg" style="width:20px; margin: 5px"
                             title="Edit"
                             type="image"/>
                      <input (click)="deleteStakeholder(i)" src="/assets/img/delete.svg" style="width:20px; margin: 5px"
                             title="Delete"
                             type="image"/>
                    </div>
                  </td>
                  <ng-container *ngIf="selected_stakeholder?.i == i;else show">
                    <td style="align-content: center;">
                      <input [(ngModel)]="selected_stakeholder.email"
                             [class.ng-invalid]="!GritUserService.validateEmail(selected_stakeholder.email)" name="email"
                             style="border: 1px solid; border-radius: 3px; text-align: center"
                             type="text">
                    </td>
                  </ng-container>
                  <ng-template #show>
                    <td style="align-content: center;">{{ el }}</td>
                  </ng-template>
                </tr>

                <tr>
                  <td>
                    <div style="display: flex; justify-content: space-evenly">
                      <input (click)="addStakeholder(newEmail.value ); newEmail.value = ''"
                             *ngIf="GritUserService.validateEmail(newEmail.value)" src="/assets/img/create.svg"
                             style="width:20px; margin: 5px"
                             title="Edit"
                             type="image"/>
                    </div>
                  </td>
                  <td style="align-content: center;">
                    <input #newEmail [class.ng-invalid]="!GritUserService.validateEmail(newEmail.value) " id="email" name="email"
                           placeholder="example@email.com"
                           style="border: none;text-align: center"
                           type="text">
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="btn" style="border: none">
              <div class="input-fields">
                <div>
                  <label for="mailing_lists">Mailing List</label>
                  <select #mailing_list id="mailing_lists" name="mailing_lists" style="margin-right: 15px;">
                    <option *ngFor="let list of gritUserService.profile.mailingList; let i = index"
                            [value]="i">{{ list.name }}
                    </option>
                  </select>

                  <button (click)="loadMailingList(Number(mailing_list.value))">Load</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <ng-container *ngIf="!interferenceTestService.allowedStates(InterferenceTestModelStates.Approval)">
        <fieldset class="fields__block" style="max-height: 100%; overflow: scroll;"
                  [disabled]="interferenceTestService.allowedStates(InterferenceTestModelStates.Archived)
                  || !gritUserService.allowedRoles(GritUserRoleGroup.ApprovingEntity, GritUserRoleGroup.FullUser)">
          <div class="fields__block__section">
            <div class="title">
              <h4>Draft Approval NOTAM</h4><span> </span>
            </div>

            <app-grit-notam
              [notamType]="NotamType.NEW"
              [notam]="interferenceTestService.detailsTab.selected.notamAccept"
              [reset]="generateAcceptNOTAM.bind(this)"
              [save]="saveNOTAM.bind(this, 'accept')"
              [send]="sendNOTAM.bind(this, interferenceTestService.detailsTab.selected.notamAccept)">
            </app-grit-notam>
          </div>
        </fieldset>
      </ng-container>

      <ng-container *ngIf="interferenceTestService.allowedStates(InterferenceTestModelStates.Approval)">
        <div class="fields__btn">

          <button #approveButton (click)="trigger('Approve')"
                  [disabled]="!gritUserService.allowedRoles(GritUserRoleGroup.ApprovingEntity)"
                  [ngClass]="approveButton.disabled  ? 'gray' : 'white'"
                  type="button">Approve
          </button>

          <button (click)="trigger('Refuse')"
                  [disabled]="approveButton.disabled"
                  [ngClass]="approveButton.disabled  ? 'gray' : 'blue'"
                  type="button">Reject
          </button>
        </div>
      </ng-container>

    </form>
  </ng-container>


  <!--Execution-->
  <ng-container *ngIf="this.interferenceTestService.detailsTab.tab == 2">
    <form #formExecution="ngForm" [class.fullscreen]="tabsService.fullScreenMode" autocomplete="off" class="active">

      <fieldset class="fields__block"
                   [disabled]="!interferenceTestService.allowedStates(InterferenceTestModelStates.Approved)
                   || !gritUserService.allowedRoles(GritUserRoleGroup.FullUser)">
        <div class="fields__block__section">
          <div class="title">
            <h4>Execution</h4><span> </span>
          </div>

          <div class="input-fields">
            <div>
              <label for="executed">Executed:</label>
              <input [(ngModel)]="interferenceTestService.detailsTab.selected.executed" id="executed" name="executed"
                     type="checkbox"/>
            </div>

            <div>
              <label for="met-cancellation">Met Specifications:</label>
              <input [(ngModel)]="interferenceTestService.detailsTab.selected.metSpecifications" id="met-cancellation"
                     name="met-cancellation"
                     type="checkbox"/>
            </div>

            <div>
              <label for="real-time-start">Real Start Date:</label>
              <input [(ngModel)]="interferenceTestService.detailsTab.selected.realDateStartISO" id="real-time-start" name="real-time-start"
                     type="datetime-local"/>
              <span class="error">
                Please note: The dates you enter are in UTC (Coordinated Universal Time)
              </span>
            </div>

            <div>
              <label for="real-time-end">Real End Date:</label>
              <input [(ngModel)]="interferenceTestService.detailsTab.selected.realDateEndISO" id="real-time-end" name="real-time-end"
                     type="datetime-local"/>
            </div>

            <div>
              <label for="disturbances">Disturbances:</label>
              <textarea [(ngModel)]="interferenceTestService.detailsTab.selected.disturbances" id="disturbances" name="disturbances"
                        style="height: 75px;min-height: 75px"></textarea>
            </div>

            <div>
              <label for="remarks">Additional Remarks:</label>
              <textarea [(ngModel)]="interferenceTestService.detailsTab.selected.remarks" id="remarks" name="remarks"
                        style="height: 75px;min-height: 75px"></textarea>
            </div>
          </div>

        </div>
      </fieldset>
      <ng-container *ngIf="interferenceTestService.allowedStates(InterferenceTestModelStates.Archived_Cancelled)">
        <fieldset class="fields__block" style="max-height: 100%; overflow: scroll;"
                     [disabled]="!gritUserService.allowedRoles(GritUserRoleGroup.FullUser, GritUserRoleGroup.ApprovingEntity)">
          <div class="fields__block__section">
            <div class="title">
              <h4>Draft Cancellation NOTAM</h4><span> </span>
            </div>

            <app-grit-notam
              [notamType]="NotamType.CANCELLATION"
              [notam]="interferenceTestService.detailsTab.selected.notamCancel"
              [reset]="generateCancellationNOTAM.bind(this)"
              [save]="saveNOTAM.bind(this, 'cancel')"
              [send]="sendNOTAM.bind(this, interferenceTestService.detailsTab.selected.notamCancel)">
            </app-grit-notam>
          </div>
        </fieldset>
      </ng-container>


      <ng-container *ngIf="interferenceTestService.allowedStates(InterferenceTestModelStates.Approved)">
        <div class="fields__btn">
          <button #completeButton (click)="trigger('Complete')"
                  [disabled]="!gritUserService.allowedRoles(GritUserRoleGroup.FullUser)"
                  [ngClass]="completeButton.disabled  ? 'gray' : 'white'"
                  type="button">Complete
          </button>
          <button (click)="trigger('Cancel')" [disabled]="completeButton.disabled"
                  [ngClass]="completeButton.disabled  ? 'gray' : 'blue'"
                  type="button">Cancel
          </button>
        </div>
      </ng-container>
    </form>
  </ng-container>
</div>
